import React, { lazy } from 'react';
import { dailyLogColumns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const DailyLogs = ({ data, i18n, viewReport }) => {
  const generateRows = () => {
    const updatedList = data?.map((item) => {
      var result = {};
      result.fullName = item.items[0];
      result.hoursDriving = item.items[1];
      result.phone = item.items[2];
      result.hours =
        item && item.link ? (
          <a
            className="viewReportNewTab"
            onClick={() => {
              viewReport({
                apiId: 'viewReportApi',
                data: item.link.replace('./document/open/', ''),
              });
            }}
          >
            {i18n.t('accidents.viewReport')}
          </a>
        ) : (
          '-'
        );
      return result;
    });
    return updatedList;
  };

  return (
    <>
      <Table
        type="client"
        title=""
        columns={dailyLogColumns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        actions={[]}
        i18n={i18n}
        noPagination
      />
    </>
  );
};

export default DailyLogs;

DailyLogs.defaultProps = {};

DailyLogs.propTypes = {};
